<!--分析中绘图部分的展示方式-->
<template>
  <div style="width: 100%">
    <el-card style="margin-top: 40px" v-if="resultMorePdfState" shadow="never">
      <!--      //三层-->
      <el-tabs v-if="resultPdfList.length>6" v-model="resultPdfNameFirst" @tab-click="clickFir">
        <el-tab-pane :name="resultPdfNameFirst" style="margin-bottom: 20px">
          <template v-slot:label>
            <el-select v-model="resultPdfNameFirst" filterable placeholder="请选择"
                       @change="handleSelectedTag">
              <el-option
                v-for="(elemF, index) in resultPdfList"
                :key="index"
                :label="elemF.tagName"
                :value="elemF.tagName">
              </el-option>
            </el-select>
          </template>
          <!--          二级-->
          <el-tabs v-if="selectedTag.sonTag.length>6" v-model="resultPdfNameSecond">

            <el-tab-pane :name="resultPdfNameSecond">
              <template v-slot:label>
                <el-select v-model="resultPdfNameSecond" filterable placeholder="请选择"
                           @change="handleSelectedTagSec">
                  <el-option
                    v-for="(elemF, index) in selectedTag.sonTag"
                    :key="index"
                    :label="elemF.tagName"
                    :value="elemF.tagName">
                  </el-option>
                </el-select>
              </template>
              <ModifyTabInner :tab-name="resultPdfNameThird" :tabList="selectedTagSec.sonTag"
                              :show-tag="selectedTagSec.sonTag.length>6" :floor="2"
                              :projectId="projectId" :index="selectedTagIndexSec"
                              :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup" ></ModifyTabInner>

            </el-tab-pane>
          </el-tabs>
          <el-tabs v-else v-model="resultPdfNameSecond">
            <el-tab-pane
              v-for="(itemSecond, indexSec) in selectedTag.sonTag"
              :key="indexSec"
              :label="itemSecond.tagName"
              :name="itemSecond.tagName">
              <ModifyTabInner :tab-name="resultPdfNameThird" :tabList="itemSecond.sonTag"
                              :show-tag="itemSecond.sonTag.length>6"
                              :projectId="projectId" :index="selectedTagIndex"
                              :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup"></ModifyTabInner>

            </el-tab-pane>
          </el-tabs>

        </el-tab-pane>
      </el-tabs>
      <!--      三层-->
      <el-tabs v-else v-model="resultPdfNameFirst" @tab-click="clickFir">
        <el-tab-pane
          v-for="(item, index) in resultPdfList"
          :key="index"
          :label="item.tagName"
          :name="item.tagName" style="margin-bottom: 20px">
          <el-tabs v-if="item.sonTag.length>6" v-model="resultPdfNameSecond">
            <el-tab-pane>
              <template v-slot:label>
                <el-select v-model="resultPdfNameSecond" filterable placeholder="请选择"
                           @change="handleSelectedTag">
                  <el-option
                    v-for="(elemF, index) in selectedTag.sonTag"
                    :key="index"
                    :label="elemF.tagName"
                    :value="elemF.tagName">
                  </el-option>
                </el-select>
              </template>
              <ModifyTabInner :tab-name="resultPdfNameThird" :tabList="selectedTag.sonTag"
                              :show-tag="selectedTag.sonTag.length>6"
                              :projectId="projectId" :index="selectedTagIndex"
                              :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup"></ModifyTabInner>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-else v-model="resultPdfNameSecond" @tab-click="clickSec">
            <el-tab-pane
              v-for="(itemSecond, indexSec) in item.sonTag"
              :key="indexSec"
              :label="itemSecond.tagName"
              :name="itemSecond.tagName">
              <ModifyTabInner :tab-name="resultPdfNameThird" :tabList="itemSecond.sonTag"
                              :show-tag="itemSecond.sonTag.length>6"
                              :projectId="projectId" :index="selectedTagIndex"
                              :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup"></ModifyTabInner>
              <template>
              </template>
            </el-tab-pane>
          </el-tabs>

        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!--      //二层ok-->
    <el-card v-if="twoFloor" shadow="never" style="margin-top: 40px">
      <div>
        <!--        二层中第一级大于6-->
        <el-tabs v-if="resultPdfList.length>6" v-model="resultPdfNameFirst" @tab-click="clickFir">
          <el-tab-pane :name="resultPdfNameFirst">
            <template v-slot:label>
              <el-select v-model="resultPdfNameFirst" filterable placeholder="请选择"
                         @change="handleSelectedTag">
                <el-option
                  v-for="(elemF, index) in resultPdfList"
                  :key="index"
                  :label="elemF.tagName"
                  :value="elemF.tagName">
                </el-option>
              </el-select>
            </template>
            <ModifyTabInner :show-tag="selectedTag.sonTag.length>6" :tab-name="resultPdfNameSecond"
                            :tabList="selectedTag.sonTag" :key="Math.random().toString(36).substring(2, 9)"
                            :projectId="projectId" :index="selectedTagIndex"
                            :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup"></ModifyTabInner>

          </el-tab-pane>
        </el-tabs>
        <!--        二层中第一级小于6-->
        <el-tabs v-else v-model="resultPdfNameFirst" @tab-click="clickFir">
          <el-tab-pane
            v-for="(item, index) in resultPdfList"
            :key="index"
            :label="item.tagName"
            :name="item.tagName" style="margin-bottom: 20px"
          >
            <ModifyTabInner :show-tag="item.sonTag.length>6" :tab-name="resultPdfNameSecond" :tabList="item.sonTag"
                            :projectId="projectId" :index="index"
                            :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup"></ModifyTabInner>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!--    一层-->
    <el-card v-if="oneFloor" shadow="never" style="margin-top: 40px">
      <ModifyTabInner :tab-name="resultPdfNameOneFir" :tabList="resultPdfListOne" :show-tag="resultPdfListOne.length>6"
                      :projectId="projectId" :index="1"
                      :analyzeId="analyzeId" :path="path" :nonGroup="nonGroup"></ModifyTabInner>
    </el-card>
    <!--    //平铺-->
    <div>
      <el-card shadow="never" style="margin-top: 40px" v-if="resultPdfState">
        <div v-for="(item, index) in resultPdfTile" :key="index" style="will-change: transform;">
          <p class="pictureName" style="margin-bottom: 30px">
            {{ normalizeShowFileName(index + 1, item.filename) }}
            <i class="el-icon-question pictureQuestion" title="提示" ref="popoverElementTile" data-trigger="hover"
               data-container="body" data-toggle="popover" data-placement="right" data-html="true"
               :data-content="openPictureQuestion(item.filename,item.folder)">
              <!--              getPictureCon(item.filename,item.folder)-->
            </i></p>

          <div style="display: flex;">
            <FilePdf :projectId="projectId" :analyzeId="analyzeId" :path="path"
                     :folder="item.folder" :fileName="item.filename" :ref="'tilePdfList'+index" :types="'pdf'"
                     :index="index"
                     style="width: 53%;height:675px;"
            ></FilePdf>
            <ModifyParam :analyzeId="analyzeId" :path="path" :projectId="projectId" :index="index" :countType="'tile'"
                         :folder="item.folder" style="width: 42%" @updatePdf="updatePdf" :nonGroup="nonGroup"></ModifyParam>
          </div>
          <el-divider></el-divider>
        </div>

      </el-card>
    </div>
    <el-card shadow="never" style="padding: 15px;margin-top: 40px" v-if="resultMoreHtmlState">
      <div v-if="resultHtmlList.length>6">
        <el-tabs v-model=" resultHtmlName">
          <el-tab-pane :name=" resultHtmlName">
            <template v-slot:label>
              <el-select v-model=" resultHtmlName" filterable placeholder="请选择">
                <el-option
                  v-for="(elemF, index) in resultHtmlList"
                  :key="index"
                  :label="elemF.fileList[0].filename"
                  :value="elemF.fileList[0].filename">
                </el-option>
              </el-select>
            </template>
            <p class="pictureName" style="margin-top: 10px!important;margin-bottom: 20px">
              {{ resultHtmlName}}
              <i class="el-icon-question pictureQuestion"
                 title="提示" ref="popoverElementTwo" data-trigger="hover"
                 data-container="body" data-toggle="popover" data-placement="right" data-html="true"
                 :data-content="getHtmlCon(resultHtmlName,getHtmlFolder(resultHtmlName))"></i>
            </p>
            <div style="width: 100%;margin-top: 0px;min-height: 600px;" v-if="resultHtmlState">
              <el-button @click="downHtml()" style="margin-bottom: 30px">下载{{ resultHtmlName }}html文件</el-button>
              <FilePdf :projectId="projectId" :analyzeId="analyzeId" :path="path"
                       :folder="getHtmlFolder(resultHtmlName)" :fileName="resultHtmlName"
                       style="width:100%" :types="'html'" :key="Math.floor(10000 * Math.random())"
              ></FilePdf>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-else>
        <el-tabs v-model="resultHtmlName">
          <el-tab-pane
            v-for="(item, index) in resultHtmlList"
            :key="index"
            :label="item.fileList[0].filename"
            :name="item.fileList[0].filename" style="margin-bottom: 20px;height: 0px!important;">
            <p class="pictureName" style="margin-top: 0px!important;">
              {{ resultHtmlName}}
              <i class="el-icon-question pictureQuestion"
                 title="提示" ref="popoverElementTwo" data-trigger="hover"
                 data-container="body" data-toggle="popover" data-placement="right" data-html="true"
                 :data-content="getHtmlCon(resultHtmlName,getHtmlFolder(resultHtmlName))"></i>
            </p>
          </el-tab-pane>
        </el-tabs>
        <div style="width: 100%;margin-top: 0px;min-height: 600px;" v-if="resultHtmlState">
          <el-button @click="downHtml()" style="margin-bottom: 30px;margin-top: 20px">下载{{ resultHtmlName }}html文件</el-button>
          <FilePdf :projectId="projectId" :analyzeId="analyzeId" :path="path"
                   :folder="getHtmlFolder(resultHtmlName)" :fileName="resultHtmlName"
                   style="width:100%" :types="'html'" :key="Math.floor(10000 * Math.random())"
          ></FilePdf>
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="pictureName"
      :visible.sync="pictureQuestionState"
      width="600px"
    >
      <h4>图片说明</h4>
      <div style="white-space: pre-line;text-indent: 2em;padding: 5px;font-size:16px" v-html="pictureContent">

      </div>

    </el-dialog>
  </div>
</template>


<script>
import $ from 'jquery'
import '../jquery/jQuery-3.2.1'
import FilePdf from "@/components/FilePdf";
import ModifyParam from "@/components/ModifyParam";
import Upload from "@/components/Upload";
import {addZero, checkIsNumber, fileDownload, normalizeShowFileName} from "@/utils/utils";
import {mapState} from "vuex";
import passPdfFile from "@/store/modules/passPdfFile";
import {getFate} from "@/utils/wordConvert";
import {getHtmlCon, getPictureCon} from "@/utils/notes";
import {sampleSize} from '@/utils/uploadFileSize'
import ModifyTabInner from "@/components/ModifyTabInner";
import {getAnalyzeGroupSampleNames} from "@/api/analyze/analyze";
import {saveDataToLocalStorage} from "@/utils/localStorageUtils";
import {getDataInSessionStorage} from "@/utils/sessionStorage";

export default {
  name: "Modify",
  components: {ModifyTabInner, ModifyParam, FilePdf, Upload},
  props: {
    analyzeId: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      resultData: [],
      showDownloadModelResult: false,
      // resultState:true,
      resultName: '',
      resultSelect: [],
      pathSplit: 0,
      pathIndexFir: 0,
      pathIndexSec: 0,
      showPdf: false,
      noHtml: false,
      resultMorePdfState: false,
      resultPdfList: [],
      resultPdfName: '',
      resultMoreHtmlState: false,
      resultPdfState: false,
      resultHtmlList: [],
      resultHtmlName: '',
      resultHtmlState: false,
      loading: true,
      resultPdfNameSecond: '',
      resultPdfNameFirst: '',
      resultPdfNameThird: '',
      oneFloor: false,
      twoFloor: false,
      resultPdfListOne: [],
      resultPdfListTwo: [],
      resultPdfTile: [],
      resultPdfNameTwoFir: '',
      resultPdfNameTwoSec: '',
      resultPdfNameOneFir: '',
      fate: [],
      resultHtmlList1: [],
      uploadProperty: {
        fileSize: sampleSize,
        types: new Set(['txt', 'xls'])
      },
      pictureQuestionState: false,
      pictureContent: '',
      pictureName: '',
      selectedTag: {},
      selectedTagSec: {},
      selectedTagIndex: 0,
      selectedTagIndexSec: 0,
      nonGroup:false
    }
  },
  created() {
    var path = getDataInSessionStorage('lastPath')
    if (path) {
      this.pathSplit = JSON.parse(JSON.stringify(path.lastIndexOf("/")))
      this.pathIndexFir = JSON.parse(JSON.stringify(path.substring(0, path.indexOf("."))))
      this.pathIndexSec = JSON.parse(JSON.stringify(path.substring(this.pathSplit + 1, this.pathSplit + 3)))
      if (!checkIsNumber(this.pathIndexSec, 'number')) {
        this.pathIndexSec = JSON.parse(JSON.stringify(path.substring(this.pathSplit + 1, path.length)))
      }
    }
    let that = this
    this.judgeNoGroup()

  },
  mounted() {
    this.getResultFile()
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },
  updated() {
    const popoverElementTile = this.$refs.popoverElementTile;
    const popoverElementOne = this.$refs.popoverElementOne;
    const popoverElementTwo = this.$refs.popoverElementTwo;
    const popoverElementThree = this.$refs.popoverElementThree;
    $(popoverElementTile).popover();
    $(popoverElementOne).popover();
    $(popoverElementTwo).popover();
    $(popoverElementThree).popover();
  },
  methods: {
    handleSelectedTag(value) {
      const index = this.getIndexSelectTag(value, this.resultPdfList)
      this.selectedTag = this.resultPdfList[index]
      this.selectedTagIndex = index
      this.resultPdfNameSecond = this.resultPdfList[index].sonTag[0].tagName
    },
    handleSelectedTagSec(value) {
      const index = this.getIndexSelectTag(value, this.selectedTag.sonTag)
      this.selectedTagSec = this.selectedTag.sonTag[index]
      this.selectedTagIndexSec = index
      this.resultPdfNameThird = this.selectedTag.sonTag[index].sonTag[0].tagName
    },
    getIndexSelectTag(value, obj) {
      const index = obj.findIndex(obj => obj.tagName === value)
      return index
    },
    normalizeShowFileName(third, name) {//规范名字的展示，01-01-01.xxx
      // pathIndexFir + '-' + pathIndexSec + '-' + addZero(index + 1) + (index + 1) + '.' + item.filename + '分析结果图'
      var finalName = normalizeShowFileName(this.pathIndexFir, this.pathIndexSec, third, name)
      if (finalName) {
        return finalName + '分析结果图'
      } else return ""
    },
    openPictureQuestion(fileName, folder) {
      const html = `${getPictureCon(fileName, folder)}`
      return `${html}`
    },
    getHtmlCon(fileName, folder) {
      return getHtmlCon(fileName, folder)
    },

    clickFir(tab, event) {
      this.resultPdfNameSecond = this.resultPdfList[tab.index].sonTag[0].tagName
      if (this.resultPdfList.length > 6) {
        this.selectedTag = this.resultPdfList[tab.index]
      } else {
        // 第一层小于6
        // this.selectedTagSec = this.resultXlsOut[tab.index].sonTag[0]
      }
    },
    clickSec(tab, event) {
      let length = this.resultPdfList.length
      let out = this.resultPdfList
      for (var i = 0; i < length; i++) {
        if (this.resultPdfList[i].tagName === this.resultPdfNameFirst) {
          this.resultPdfNameThird = this.resultXlsOut[i].sonTag[tab.index].sonTag[0].tagName
        }
      }
    },
    getResultPdfFolder(resultPdfName) {
      if (resultPdfName) {
        let folder = ''
        let resultPdfList = this.resultPdfList
        this.resultPdfList.forEach(function (item, index) {
          if (item.name === resultPdfName) {
            folder = resultPdfList[index].folder
          }
        })
        return folder
      }
    },
    async downHtml() {
      let folder = this.getHtmlFolder(this.resultHtmlName)
      const data = await this.$http({
        method: 'get',
        url: '/preview/view/' + this.projectId + "/" + this.analyzeId + "/" + folder,
        responseType: 'blob',
      })
      fileDownload(data, this.resultHtmlName)
    },
    updatePdf(folder, index, count) {
      let currentIndex = 'tilePdfList' + index
      this.$refs[currentIndex][0].getPdf(folder, 2)
    },
    async getResultFile() {
      if (this.path !== '') {
        this.showDownloadModelResult = true
        const res = await this.$http.get('/preview/dirFiles/' + this.projectId + "/" + this.analyzeId + "/" + this.path)
        // const res = getFate()
        if (res.code === 200) {
          let data = res.data
          data.forEach(elem => {
            let type = elem.typeName
            let length = elem.tags.length
            let tagsCon = elem.tags
            if (type === 'img') {
              if (length >= 1) { //至少有一个tag或者一个img
                let sonTag
                let fileList //判断一个tag里面会有几张图
                tagsCon.forEach(inElem => {
                  sonTag = inElem.sonTag
                  fileList = inElem.fileList
                })
                if (sonTag) {
                  //二级及以上
                  if (sonTag.length >= 1) { //完全确保有二级，以防出现空
                    let sonTagSec = sonTag[0].sonTag
                    if (sonTagSec) {//三级
                      if (sonTagSec.length >= 1) {
                        this.resultMorePdfState = true
                        this.resultPdfList = tagsCon
                        this.selectedTag = tagsCon[0]
                        this.resultPdfNameFirst = tagsCon[0].tagName
                        this.resultPdfNameSecond = tagsCon[0].sonTag[0].tagName
                        this.resultPdfNameThird = tagsCon[0].sonTag[0].sonTag[0].tagName

                      } else {
                        //二级
                        this.twoFloor = true
                        this.selectedTag = tagsCon[0]
                        this.resultPdfList = tagsCon
                        this.resultPdfNameFirst = tagsCon[0].tagName
                        this.resultPdfNameSecond = tagsCon[0].sonTag[0].tagName
                      }
                    } else {
                      //二级
                      this.twoFloor = true
                      this.resultPdfList = tagsCon
                      this.selectedTag = tagsCon[0]
                      this.resultPdfNameFirst = tagsCon[0].tagName
                      this.resultPdfNameSecond = tagsCon[0].sonTag[0].tagName
                    }
                  }
                  //未对每一个做校验，所以有些既有sontag,又有平铺
                  if (fileList) {
                    if (fileList.length >= 1) {
                      //平铺
                      this.resultPdfState = true
                      this.resultPdfTile = tagsCon[0].fileList
                    }
                  }

                } else {
                  //有两种情况，一级或者平铺
                  if (fileList) {
                    if ((fileList.length > 0) && (length === 1)) {
                      //平铺
                      this.resultPdfState = true
                      this.resultPdfTile = tagsCon[0].fileList
                    } else {
                      //一级
                      if(length===1&&fileList.length===0){
                        this.$store.commit('setModifyLoading', 'noPdf')
                      }else{
                        this.oneFloor = true
                        this.resultPdfListOne = tagsCon
                        this.resultPdfNameOneFir = tagsCon[0].tagName
                      }
                    }
                  }
                }
              } else {
                this.$store.commit('setModifyLoading', 'noPdf')
              }
            } else if (type === 'html') {
              if (length >= 1) {
                this.resultMoreHtmlState = true
                this.resultHtmlState = true
                this.resultHtmlList = tagsCon
                this.resultHtmlName = tagsCon[0].fileList[0].filename
                let folder = []
                let length = tagsCon.length
                for (let i = 0; i < length; i++) {
                  let value = tagsCon[i]
                  folder.push({
                    folder: value.fileList[0].folder,
                    name: value.fileList[0].filename
                  })
                }
                this.resultHtmlList1 = folder
              }
            }
          })
        }
      } else {
        this.showDownloadModelResult = false
      }
    },
    resultListNoPdf(resultName) {
      let index = 0
      this.$store.commit('setResultName', (this.resultName))
      saveDataToLocalStorage('resultNames', this.resultName)
      for (let elem in this.resultSelect) {
        let value = this.resultSelect[elem].name
        if (value === resultName) {
          index = elem
        }
      }
      if (this.resultData[index]) {
        let arr = JSON.parse(JSON.stringify(this.resultData[index]._2))
        let returnArr = []
        if (arr) {
          arr.forEach(function (item, key) {
            if (item.name.endsWith('pdf') || item.name.endsWith('png') || item.name.endsWith('jpg')) {
              returnArr.push(item)
            }
          })
          if (returnArr.length !== 0) {
            this.showPdf = true
            return returnArr
          }
        }
      }
    },
    addZero(value) {
      return addZero(value)
    },
    getHtmlFolder(resultHtmlName) {
      let folder = ''
      if (resultHtmlName) {
        let resultHtmlList = this.resultHtmlList1
        this.resultHtmlList1.forEach(function (item, index) {
          if (item.name === resultHtmlName) {
            folder = resultHtmlList[index].folder
          }
        })
      }
      return folder
    },
    async getResult(folder) {
      const result = await this.$http({
        method: 'get',
        url: '/preview/view/' + this.projectId + "/" + this.analyzeId + "/" + folder,
        responseType: 'blob',
      })
      var binaryData = [];
      binaryData.push(result);
      let url = window.URL.createObjectURL(
        new Blob(binaryData, {
          type: " text/html;charset=utf-8",
        })
      );
      if (url !== null && url !== undefined && url) {
        return url

      } else {
        return ''
      }
    },
    getHtmlSrc(resultHtmlName) {
      let folder = this.getHtmlFolder(resultHtmlName)
      let url = this.getResult(folder)
      return url
    },
    disappearLoad() {
      this.loading = false
    },
    judgeNoGroup() {
      getAnalyzeGroupSampleNames(this.analyzeId).then(data => {
        this.nonGroup = data.nonGroup
      })
    },
  },
}
</script>

<style scoped>
.pictureName {
  /*list-style-type: disc;*/
  color: #1e6cb0;
  margin: 30px 0px;
}

.pictureQuestion {
  cursor: pointer;
  /*color: #afbdde;*/
  color: #2a7fc9;

}

/deep/ .el-dialog__header {
  background-color: #477cb2;
  padding: 10px;
  color: #e0e0e0;
}

/deep/ .el-dialog__title {
  /*color: #efecec;*/
  color: #e0e0e0;

}

/deep/ .el-dialog__headerbtn {
  top: 10px;
}

/deep/ .el-dialog__body {
  padding: 18px;
}
</style>
